module.exports = __webpack_public_path__ + "static/media/no_invitations.51fbcdfa.png";